import React, { useEffect, useState } from 'react';
import { useRive, useStateMachineInput } from '@rive-app/react-canvas';
import { useGlobalContext } from './GlobalProvider';

interface OpponentProps {
  state: number;
  winner: number;
  speaking: boolean;
  speachState: number;
}

interface Quote {
  id: number;
  text: string;
  state: string;
}

  const Opponent: React.FC<OpponentProps> = ({ state, winner, speaking, speachState }) => {
      
      const { walletAddress } = useGlobalContext();
      const [quoteData, setQuoteData] = useState<string | object>("");
      const [quotes, setQuotes] = React.useState<Quote[]>([]);
      const [kingSpeaks, setKingSpeaks] = useState<boolean>(false);
  
      const tester = useRive({
          src: './animation/llama_king.riv',
          stateMachines: 'MainSM',  
          autoplay: true,        
          artboard: 'Main'          
      });
  
      const stateMachineInput = useStateMachineInput(tester.rive, 'MainSM', 'stateIndex');
      const outcomeIndexInput = useStateMachineInput(tester.rive, 'MainSM', 'outcomeIndex');
      const speakingInput = useStateMachineInput(tester.rive, 'MainSM', 'speaking');

      useEffect(() => {
      
        if(outcomeIndexInput && typeof outcomeIndexInput.value === 'number') {
          console.log("Outcome Index: " + outcomeIndexInput.value);
          outcomeIndexInput.value = winner; 
        }

      }, [winner]);

    useEffect(() => {
        if(stateMachineInput && typeof stateMachineInput.value === 'number') {
            stateMachineInput.value = state;
        }
    }, [state]);

    useEffect(() => {
      // const randomChance = Math.random();

      // if( randomChance < 0.2 ) {
      //   if(speakingInput && typeof speakingInput.value === 'boolean') {
      //     setKingSpeaks(true);

      //     if(speakingInput && typeof speakingInput.value === 'boolean') {
      //       tester.rive?.setTextRunValue('Speech_Lbl', "" + getRandomQuoteByState(getQuoteState(state))?.text);
      //       speakingInput.value = speaking;
      //     }
      //   }
      // } else {
      //   setKingSpeaks(false);
      // }

      if(speakingInput && typeof speakingInput.value === 'boolean') {
        setKingSpeaks(true);

        if(speakingInput && typeof speakingInput.value === 'boolean') {
          tester.rive?.setTextRunValue('Speech_Lbl', "" + getRandomQuoteByState(getQuoteState(state))?.text);
          speakingInput.value = speaking;
        }
      }
      
    }, [speaking]);

    useEffect(() => {
      if(kingSpeaks) {
        tester.rive?.setTextRunValue('Speech_Lbl', "" + getRandomQuoteByState(getQuoteState(speachState))?.text);
      } else {
        tester.rive?.setTextRunValue('Speech_Lbl', "");
      }
    }, [kingSpeaks]);
    

    useEffect(() => {
      console.log("Quotes Data: ", quoteData);
      if(quoteData === "") return;
      if (typeof quoteData === "string") {
        try {
          const parsedData = JSON.parse(quoteData);
          console.log("Parsed Data: ", parsedData);
          if (parsedData.llamaKingQuotes) {
            setQuotes(parsedData.llamaKingQuotes);
          }
        } catch (error) {
          console.error("Error parsing JSON data: ", error);
        }
      } else if (typeof quoteData === "object") {
        console.log("Quote data is already an object: ", quoteData);
        if ((quoteData as any).llamaKingQuotes) {
          setQuotes((quoteData as any).llamaKingQuotes);
        }
      }
    }, [quoteData]);

    useEffect(() => {
      if (quotes.length > 0) {
        const randomQuote = getRandomQuoteByState('roundWon'); // For example, for "roundWon" state
        console.log("Random Quote for 'roundWon': ", randomQuote);
      }
    }, [quotes]);
    

    const getQuoteState = ( indx: number ) => {

      switch( indx ) {
          case 0: // return neutral quote
            return "neutral";
          case 1: // return mad quote
              return "roundLost";
          case 2: // return happy quote
              return "roundWon";
          case 3: // return very mad quote
              return "roundWarLost";
          case 4: // return very happy quote
              return "roundWarWin";
          case 5: 
              return "gameLost";
          case 6:
              return "gameWon";
          default: // return neutral quote
              return "neutral";
      }
  };

    const getRandomQuoteByState = (state: string) => {
      const filteredQuotes = quotes.filter(quote => quote.state === state);
      if (filteredQuotes.length > 0) {
        const randomIndex = Math.floor(Math.random() * filteredQuotes.length);
        return filteredQuotes[randomIndex];
      } else {
        return null;
      }
    };

    useEffect(() => {
      const fetchCardData = async () => {
          try {
              const response = await fetch('./json/llama_king_quotes.json');
              const data = await response.json();
              setQuoteData(data);
          } catch (error) {
              console.error("Error fetching card data:", error);
          }
      };

      fetchCardData();
    }, []);

    
      return (
        <>
            <tester.RiveComponent 
                style={{ 
                    width: '100%', 
                    minWidth: '960px',
                    height: 'auto', 
                    maxHeight: '424px', 
                    aspectRatio: '16/9', 
                    objectFit: 'cover', 
                    alignSelf: 'flex-end'
                }} 
            />
        </>
      );
  };
  
  export default Opponent;
  
